import axios from 'axios';
import { APIENDPOINT } from '../../../app.config.js';
import { leerToken, cerrarSesion } from './sesion';

/**
 * Cliente HTTP de Seway Plus Negocios.
 *
 * Es una INSTANCIA PROPIA de axios, deliberadamente separada del axios global
 * del ERP. El ERP fija `axios.defaults.headers.common['Authorization']` con la
 * cookie de su sesión desde el guard de main.js; si el módulo de anunciantes
 * usara ese mismo axios, los dos tokens se mezclarían en ambos sentidos.
 *
 * Aquí el token del anunciante se lee de localStorage y se inyecta por
 * interceptor, una sola vez y con un único prefijo "Bearer" (el ERP tiene el
 * bug de anteponerlo dos veces: "Bearer Bearer eyJ...").
 */
const api = axios.create({
    baseURL: APIENDPOINT,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
});

api.interceptors.request.use((config) => {
    const token = leerToken();
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
});

api.interceptors.response.use(
    (respuesta) => respuesta,
    (error) => {
        // 401 = el token caducó o fue revocado. Se limpia la sesión local para
        // que la interfaz no siga creyendo que hay usuario.
        if (error && error.response && error.response.status === 401) {
            cerrarSesion();
        }
        return Promise.reject(error);
    }
);

/**
 * Extrae el mensaje de error más útil de una respuesta del backend.
 */
export function mensajeDeError(error, porDefecto = 'Ocurrió un error. Inténtalo de nuevo.') {
    if (!error || !error.response || !error.response.data) {
        return porDefecto;
    }

    const datos = error.response.data;

    if (datos.errors) {
        const primera = Object.keys(datos.errors)[0];
        if (primera && Array.isArray(datos.errors[primera]) && datos.errors[primera][0]) {
            return datos.errors[primera][0];
        }
    }

    return datos.message || porDefecto;
}

/**
 * Errores de validación del backend indexados por campo, para pintarlos
 * junto al input correspondiente.
 */
export function erroresDeCampo(error) {
    if (!error || !error.response || !error.response.data || !error.response.data.errors) {
        return {};
    }

    const salida = {};
    const errores = error.response.data.errors;

    Object.keys(errores).forEach((clave) => {
        salida[clave] = Array.isArray(errores[clave]) ? errores[clave][0] : errores[clave];
    });

    return salida;
}

export default api;
